import { endpoints } from 'Constants';

const userServices = {
	login: (params) => ({
		baseURL: endpoints.USER.LOGIN(),
		method: 'POST',
		data: params,
	}),
	fresh_register: (params) => ({
		baseURL: endpoints.USER.FRESH_REGISTER(),
		method: 'POST',
		data: params,
	}),
	create_business: (params) => ({
		baseURL: endpoints.USER.CREATE_BUSINESS(),
		method: 'POST',
		data: params,
	}),
	forget_password: (params) => ({
		baseURL: endpoints.USER.FORGET_PASSWORD(),
		method: 'POST',
		data: params,
	}),
	reset_password: (params) => ({
		baseURL: endpoints.USER.RESET_PASSWORD(),
		method: 'POST',
		data: params,
	}),
	register: (params) => ({
		baseURL: endpoints.USER.REGISTER(),
		method: 'POST',
		data: params,
	}),

	profile: () => ({
		baseURL: endpoints.USER.PROFILE(),
		method: 'GET',
	}),
	profileCompelete: (id) => ({
		baseURL: endpoints.USER.GET_PROFILE(id),
		method: 'GET',
	}),
	updateProfile: (params) => ({
		baseURL: endpoints.USER.UPDATE_PROFILE(params.id),
		method: 'PUT',
		data: params.data,
	}),
	changeNumberOTP: (params) => ({
		baseURL: endpoints.USER.UPDATE_PROFILE_OTP(),
		method: 'POST',
		data: params,
	}),
	changeNumberOTPConfirm: (params) => ({
		baseURL: endpoints.USER.UPDATE_PROFILE_OTP_CONFIRM(params.id),
		method: 'PUT',
		data: params.data,
	}),
	userWizard: () => ({
		baseURL: endpoints.USER.WIZARD(),
		method: 'GET',
	}),
};

export default userServices;
